module.exports = __webpack_public_path__ + "static/media/silver-chest.94511491.svg";